<template>
  <td v-if="hasContent">
    <span class="flag-icon" :class="flagClass"></span>
  </td>
  <td v-else v-html="nullHtml"></td>
</template>

<script>
import { defaultNullHtml } from "@/js/defaultNullHtml";
export default {
  props: ["content"],
  computed: {
    nullHtml() {
      return defaultNullHtml();
    },
    hasContent() {
      return this.content !== null;
    },
    flagClass() {
      return `flag-icon-${this.content.toLowerCase()}`;
    }
  }
};
</script>
